/**
 * dp-data-upload-hosts.js — Umleitung der Vendor-Endpunkte des Nachkauf-Popups (data-upload.js).
 *
 * Befund 2026-09-14: Das per Cloudinary ausgelieferte Popup-Skript trägt fest die Staging-Hosts
 * (baseUrl https://backend-fa.ignorelist.com/api/v1, FE_URL https://staging-fa.ignorelist.com),
 * die Produktseiten-App (app-new.js) arbeitet aber gegen https://backend.dp-digital.de/api/v1
 * und https://shopify.dp-digital.de. Folge: Das Popup fand keine Aufträge, blendete Knopf und
 * Fenster aus, „Kasse" konnte nie aktiv werden. Bis dp-digital das Skript korrigiert, biegt
 * dieser klassische, NICHT verzögerte Script die Aufrufe um: fetch() auf die Staging-Hosts geht
 * an die Produktions-Hosts; der Header `region` wird ergänzt (SellerRegionLookupGuard).
 *
 * Läuft VOR dem Vendor-Skript (kein defer), wirkt nur auf die zwei genannten Hosts, nie auf
 * andere Aufrufe. Konfiguration über data-Attribute am eigenen <script>-Tag:
 *   data-api-base="https://backend.dp-digital.de/api/v1" data-fe-url="https://shopify.dp-digital.de" data-region="DE"
 */
(function () {
  'use strict';
  var script = document.currentScript;
  var ds = (script && script.dataset) || {};
  var apiBase = String(ds.apiBase || 'https://backend.dp-digital.de/api/v1').replace(/\/+$/, '');
  var feUrl = String(ds.feUrl || 'https://shopify.dp-digital.de').replace(/\/+$/, '');
  var region = String(ds.region || 'DE');
  var map = [
    ['https://backend-fa.ignorelist.com/api/v1', apiBase],
    ['https://staging-fa.ignorelist.com', feUrl],
  ];
  if (typeof window.fetch !== 'function' || window.__dpUploadHostsPatched) return;
  var originalFetch = window.fetch;

  function rewrite(url) {
    for (var i = 0; i < map.length; i += 1) {
      if (url.indexOf(map[i][0]) === 0) return { target: map[i][1] + url.slice(map[i][0].length), api: i === 0 };
    }
    return null;
  }

  window.fetch = function dpUploadHostsFetch(input, init) {
    try {
      var url = typeof input === 'string' ? input : input && typeof input.url === 'string' ? input.url : null;
      var hit = url ? rewrite(url) : null;
      if (hit) {
        var target = hit.target;
        var options = init ? Object.assign({}, init) : {};
        var headers = new Headers(options.headers || (typeof input !== 'string' && input && input.headers) || undefined);
        // `region` nur für die API (SellerRegionLookupGuard). Das App-Frontend (/api/duplicate) erlaubt
        // im CORS-Preflight nur Content-Type – ein zusätzlicher Header würde dort "Failed to fetch" auslösen.
        if (hit.api && !headers.has('region')) headers.set('region', region);
        options.headers = headers;
        if (typeof input !== 'string' && input && typeof input.url === 'string') {
          if (!options.method && input.method) options.method = input.method;
          if (!options.body && input.body) options.body = input.body;
        }
        return originalFetch.call(this, target, options);
      }
    } catch (error) {
      /* Umleitung darf den Vendor nie brechen – im Zweifel Originalaufruf */
    }
    return originalFetch.call(this, input, init);
  };
  window.__dpUploadHostsPatched = { apiBase: apiBase, feUrl: feUrl, region: region };
})();
